import { createContext, useContext, useEffect, useState } from 'react'
import MessageModal from '../components/MessageModal'
import Profile from '../pages/Profile/Profile'
import { useAuth } from './AuthContext'

const UserContext = createContext()

export function useUser() {
    if (!UserContext) {
        throw new Error('Component not wrapped in UserContext')
    }
    return useContext(UserContext)
}

export function UserProvider({ children }) {
    const [user, setUser] = useState({})
    const [message, setMessage] = useState(null)
    const { auth } = useAuth()
    const [userError, setUserError] = useState(null)

    function removeUser() {
        setUser({})
    }

    function handleUserStatusCancelled(data) {
        setMessage({
            type: 'Account Cancelled',
            text: data,
            navigateTo: '/User%20Profile',
        })
    }

    useEffect(() => {
        if (userError) {
            handleUserStatusCancelled(userError)
            setUserError(null)
        }
    }, [userError])

    return (
        <UserContext.Provider
            value={{
                user,
                setUser,
                removeUser,
                handleUserStatusCancelled,
                setUserError,
            }}
        >
            {window.location.pathname === '/User%20Profile' ? (
                <Profile token={auth?.token} />
            ) : (
                children
            )}
            {message && <MessageModal message={message} setMessage={setMessage} />}
        </UserContext.Provider>
    )
}
